import { applyUiAction } from '@/composition/hosts/voice-ui-actions-host';
import { isHelpTargetId } from '@heidi/agents';
import type { GuideStep } from './useVoiceGuideStore';
import { useVoiceHighlightStore } from './useVoiceHighlightStore';

const GUIDE_HIGHLIGHT_MS = 120_000;

/** Template-row guides should open the picker, not only spotlight the row. */
const TEMPLATE_PICKER_TARGETS = new Set([
  'session.template-row',
  'session.template-picker',
]);

/** Apply navigate + spotlight / callout for the active guide step. */
export const applyGuideStepVisuals = (step: GuideStep | null | undefined) => {
  if (!step) {
    useVoiceHighlightStore.getState().clearHighlight();
    return;
  }
  if (step.href?.startsWith('/')) {
    applyUiAction({ action: 'navigate', data: { href: step.href } });
  }
  const waitFor = step.wait_for ?? 'either';
  const target = step.highlight && isHelpTargetId(step.highlight) ? step.highlight : null;
  if (target && TEMPLATE_PICKER_TARGETS.has(target)) {
    applyUiAction({ action: 'open_template_picker' });
  }
  useVoiceHighlightStore.getState().setHighlight({
    target,
    title: step.title ?? undefined,
    body: step.say,
    durationMs: GUIDE_HIGHLIGHT_MS,
    startedAt: Date.now(),
    showContinue: waitFor === 'speak_next' || waitFor === 'either' || !target,
  });
};
